/** Walking footprint — slowly steps Charge → Wear → Recover. */
(function () {
  const roots = document.querySelectorAll('[data-zm-story]');
  if (!roots.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const STEP_MS = 1600;
  const HOLD_MS = 900;
  const LOOP_PAUSE = 1400;

  roots.forEach((section) => {
    const path = section.querySelector('.zm-story-path');
    const walker = section.querySelector('[data-zm-story-walker]');
    const progress = section.querySelector('[data-zm-story-progress]');
    const nodes = [...section.querySelectorAll('[data-zm-story-node]')];
    if (!path || !nodes.length) return;

    let timer = null;
    let running = false;
    let step = 0;

    function isVertical() {
      return window.matchMedia('(max-width: 800px)').matches;
    }

    function setActive(index) {
      nodes.forEach((node, i) => {
        node.classList.toggle('is-active', i === index);
        node.classList.toggle('is-done', i < index);
      });
    }

    function moveTo(index) {
      const count = nodes.length;
      const pct = count === 1 ? 50 : (index / (count - 1)) * 100;
      const flip = index % 2 === 1;

      if (walker) {
        walker.classList.toggle('is-flip', flip);
        if (isVertical()) {
          walker.style.left = '50%';
          walker.style.top = `${pct}%`;
        } else {
          walker.style.top = '50%';
          walker.style.left = `${pct}%`;
        }
        walker.classList.remove('is-stamp');
        void walker.offsetWidth;
        walker.classList.add('is-stamp');
      }

      if (progress) {
        if (isVertical()) {
          progress.style.width = '100%';
          progress.style.height = `${pct}%`;
        } else {
          progress.style.height = '100%';
          progress.style.width = `${pct}%`;
        }
      }

      setActive(index);
    }

    function scheduleNext() {
      clearTimeout(timer);
      timer = setTimeout(() => {
        step += 1;
        if (step >= nodes.length) {
          timer = setTimeout(() => {
            step = 0;
            moveTo(0);
            scheduleNext();
          }, LOOP_PAUSE);
          return;
        }
        moveTo(step);
        scheduleNext();
      }, STEP_MS + HOLD_MS);
    }

    function start() {
      if (running || reduce) return;
      running = true;
      path.classList.add('is-on');
      step = 0;
      moveTo(0);
      scheduleNext();
    }

    function stop() {
      running = false;
      clearTimeout(timer);
    }

    if (reduce) {
      path.classList.add('is-on');
      nodes.forEach((n) => n.classList.add('is-active', 'is-done'));
      if (progress) {
        progress.style.width = '100%';
        progress.style.height = '100%';
      }
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) start();
          else stop();
        });
      },
      { threshold: 0.35 }
    );
    io.observe(section);

    window.addEventListener(
      'resize',
      () => {
        if (running) moveTo(step);
      },
      { passive: true }
    );
  });
})();
